export default {
  cards: [],
  gameSettings: {},
  currentTable: [],
  currentTurn: null,
  largePlayer: null,
  currentType: null,
  cardPlayed: null,
  sittingOut: null,
  players: {
    player1: {},
    player2: {},
    player3: {},
  },
  globalParams: {
    disableTimer: null,
    currentHand: null,
    lastRound: false,
    lastRoundPlayer: null,
    playerQuitRound: false,
    roomClosed: false,
  },
};
